import Vue from 'vue';
import SearchPanel from './SearchPanel';
import SearchCompetitorDataTable from './SearchCompetitorDataTable';

export default Vue.extend({
  props: {
    searchText: String,
    activator: String,
    sportId: Number,
  },

  render() {
    return (
      <SearchPanel activator={this.activator}>
        <SearchCompetitorDataTable
          searchText={this.searchText}
          sportId={this.sportId} />
      </SearchPanel>
    );
  },
});
